Object.defineProperty(exports, "__esModule", {
    value: true
});
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
Object.defineProperties(exports, {
    __esModule: {
        value: true
    },
    [Symbol.toStringTag]: {
        value: 'Module'
    }
});
var require_runtime = require('./_virtual/_rolldown/runtime.cjs');
var require_utils = require('./utils.cjs');
var _module_federation_runtime_core = require("@module-federation/runtime-core");
//#region src/helpers.ts
var global = _object_spread_props._(_object_spread._({}, _module_federation_runtime_core.helpers.global), {
    getGlobalFederationInstance: require_utils.getGlobalFederationInstance
});
var share = _module_federation_runtime_core.helpers.share;
var utils = _module_federation_runtime_core.helpers.utils;
var runtimeHelpers = {
    global,
    share,
    utils
};
//#endregion
exports.default = runtimeHelpers;
exports.global = global;
exports.share = share;
exports.utils = utils; //# sourceMappingURL=helpers.cjs.map
